<template>
  <SearchableDropdown
    v-model="selectedMethod"
    :name="name"
    class="m-b-10"
    :class="customClass"
    :config="methodsDropdownConfig"
    :clearable="false"
  />
</template>

<script>
import SearchableDropdown from '@/core/components/SearchableDropdown/SearchableDropdown';

export default {
  name: 'HttpMethodSelector',
  components: { SearchableDropdown },
  props: {
    name: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: null
    },
    customClass: {
      type: String,
      default: ''
    },
    customOptions: {
      type: Array,
      default: () => {
        return null;
      }
    }
  },
  computed: {
    methodsDropdownConfig() {
      let config = {
        options: [
          { label: 'GET', id: 'get' },
          { label: 'POST', id: 'post' },
          { label: 'PATCH', id: 'patch' },
          { label: 'PUT', id: 'put' },
          { label: 'DELETE', id: 'delete' },
        ],
        placeholder: 'Choose Method',
      };
      if (this.customOptions) {
        config.options = this.customOptions;
        return config;
      }
      return config;
    },
    selectedMethod: {
      get() {
        return this.methodsDropdownConfig.options.find( ({ id }) => id === this.value.toLowerCase() );
      },
      set(value) {
        this.$emit('input', value.id);
      }
    },
  }
};
</script>